import { CloseIcon } from '../icons'

interface WarningsBannerProps {
  warnings: string[]
  onDismiss: () => void
}

/** Things Claude wasn't sure about, shown once above the editor */
export const WarningsBanner = ({ warnings, onDismiss }: WarningsBannerProps) => (
  <div role="status" className="mx-6 mb-4 rounded-lg border border-amber-300 bg-amber-50 p-4 flex items-start gap-3">
    <div className="flex-1">
      <p className="text-sm font-semibold text-amber-900 mb-1">Please double-check your menu</p>
      <ul className="list-disc pl-5 text-sm text-amber-900 space-y-0.5">
        {warnings.map((warning) => (
          <li key={warning}>{warning}</li>
        ))}
      </ul>
    </div>
    <button onClick={onDismiss} className="text-amber-700 hover:text-amber-900" aria-label="Dismiss warnings">
      <CloseIcon className="w-5 h-5" />
    </button>
  </div>
)
